import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip } from "@faire/web--source/slate/Tooltip/index";
import React from "react";
import { TopShopTooltipContents } from "./TopShopTooltipContents";
export var TopShopEducationTooltip = function(_param) {
    var _param_position = _param.position, position = _param_position === void 0 ? "right" : _param_position, tooltipProps = _object_without_properties(_param, [
        "position"
    ]);
    return /*#__PURE__*/ _jsx(Tooltip, _object_spread_props(_object_spread({
        position: position,
        width: 310
    }, tooltipProps), {
        children: /*#__PURE__*/ _jsx(TopShopTooltipContents, {})
    }));
};
